var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { default as Base } from './Th.base';
import ThCheckbox from './ThCheckbox';
import ThGroup from './ThGroup';
import ThGroups from './ThGroups';
var Th = function (props) { return React.createElement(Base, __assign({}, props)); };
Th.defaultProps = {
    align: 'left',
    disabled: false,
    hidden: false,
    sortDirection: '',
    sort: [],
    __TYPE: 'Th',
};
export default Object.assign(Th, { Checkbox: ThCheckbox, Group: ThGroup, Groups: ThGroups });
